export const toFormData = <T extends Dictionary>(obj: T) => {
  const formData = new FormData();
  Object.entries(obj).forEach(([k, v]) => formData.append(k, v));
  return formData;
};

export const toQuerystring = <T extends Dictionary>(obj: T) => {
  const entries = Object.entries(obj).reduce(
    (acc, cur) => {
      const [key, value] = cur;
      const row = [] as [string, any][];

      if (Array.isArray(value)) {
        value.forEach(v => {
          row.push([key, v]);
        });
      } else {
        row.push([key, value]);
      }

      return [...acc, ...row];
    },
    [] as [string, any][],
  );

  return `${new URLSearchParams(entries)}`;
};
